import { shippingLabelFormatValues } from '@/common/constants'

export const shippingLabelFormatOptions = [
  {
    value: shippingLabelFormatValues.pdf,
    label: 'PDF',
  },
  {
    value: shippingLabelFormatValues.zpl,
    label: 'ZPL',
  },
  {
    value: shippingLabelFormatValues.pdfAndZpl,
    label: 'PDF & ZPL',
  },
]
